<template>
    <div class="webSearch">
        <Row>
            <Col span="4" style="padding-right:10px">
                <!-- v-on:input实时查询 -->
                <Input search v-model="alertRuleSearchKey" :placeholder="$t('alarms.common.filterByAlertRuleName')" @on-search="searchAlertRule()"/>
            </Col>
        </Row>
    </div>
</template>
<script>
    import TableWebWarning from '../web/TableWebWarning'
    var tableWebWarning = TableWebWarning;
    export default {
        name: 'WebWarningSearch',
        data () {
            return {
                alertRuleSearchKey:'',
                alertRuleSearchName:''
            }
        },
        methods: {
            // 按规则名称搜索
            searchAlertRule: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('alertRuleSearchName', this.alertRuleSearchKey);
                tableWebWarning.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .webSearch
    {
        height: 51px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/web/WebWarningSearch.vue